module.exports = __webpack_public_path__ + "img/fallback-song-art.a597e181.png";